import { unregister } from './serviceWorkerRegistration';
import React from 'react';
import ReactDOM from 'react-dom/client';
import BookLodgeApp from './BookLodge';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BookLodgeApp />
  </React.StrictMode>
);

// Service worker OFF, deliberately.
//
// With register(), a new build downloads but waits until every tab of the site
// is closed before taking over. On a phone, where tabs are never really closed,
// that can be days â€” lodgers kept running whatever version they first loaded,
// and fixes never reached them. A trial banner removed on Sep 15 was still
// showing on a browser tab on Sep 16 because of this.
//
// unregister() also removes any worker already installed on someone's device,
// so anyone stuck on an old build is freed on their next visit. Nothing for
// lodgers to clear themselves.
//
// What this gives up: offline support (useless here â€” every screen needs
// Supabase) and home-screen install. Web push will need a service worker again
// when notifications get built; wire one up properly then, with an update path
// that calls SKIP_WAITING instead of waiting for tabs to close.
unregister();
